import $ from 'jquery';
import {initCopyToClipboard, initSocials} from './socials-init';
import axios from 'axios';

function initSocialsComponent(app) {
    app.component('jssocials', {
        template: '#jssocials',
        props: {
            socialButtons: {
                type: Array,
                required: false,
                default() {
                    return [];
                },
            },
            linkCopiedMessage: {
                type: String,
                required: false,
            },
            isCopyLink: {
                type: Boolean,
                required: false,
            },
            dropdownSelector: {
                type: String,
                required: false,
            },
            referrerId: {
                type: String,
                required: false,
                default: '',
            },
            shareText: {
                type: String,
                required: false,
            },
            descriptionText: {
                type: String,
                required: false,
            },
            url: {
                type: String,
                required: false,
            },
            shareTrackUrl: {
                type: String,
                required: false,
            },
            shareActionButtonPrefix: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                socials: this.socialButtons,
            };
        },
        methods: {
            trackShare() {
                if (this.shareTrackUrl && !this.shareTracked) {
                    axios.post(`${this.shareTrackUrl}`)
                        .catch((error) => {
                            console.error(`unable to track share: ${error}`);
                        });
                    this.shareTracked = true;
                }
            },
            _addGATrackingInfo() {
                const pathname = new URL(this.url ? this.url : window.location).pathname;
                for (const social of this.socials) {
                    const button = this.$el.querySelector(`.js-scls-share-${social} .js-scls-share-link`);
                    button.dataset.gaTrack = 'EventOnClick';
                    button.dataset.gaTrackEventCategory = 'Social';
                    button.dataset.gaTrackEventAction = `Share via ${social}`;
                    button.dataset.gaTrackEventLabel = pathname;
                    button.dataset.gaTrackEventValue = 1;
                }
            },
            _initJsSocials() {
                if (this.isCopyLink) {
                    const copyLink = ['copy'];
                    this.socials = copyLink.concat(this.socialButtons);

                    const url = this.url ? this.url : `${window.location.origin}${window.location.pathname}${location.search}`;
                    initCopyToClipboard(url, this.$el, this.linkCopiedMessage, this.dropdownSelector, this.referrerId);
                }

                const that = this;

                $(this.$el).jsSocials({
                    showLabel: false,
                    showCount: true,
                    shareIn: 'popup',
                    shares: this.socials,
                    text: `${this.shareText}:`,
                    url: this.url,
                    on: {
                        click: that.trackShare,
                    },
                });
            },
        },
        mounted() {
            initSocials({
                descriptionText: this.descriptionText,
                shareActionButtonPrefix: this.shareActionButtonPrefix,
            });
            this._initJsSocials();
            this._addGATrackingInfo();
        },
    });
}

export default initSocialsComponent;
